import React from 'react';
import { User2 } from 'lucide-react';
import { Separator } from '@/components/ui/separator';
import type { GlobalSearchHit } from '../types';
import FieldList from './FieldList';
import HighlightedText from './HighlightedText';
import ViewDetailsLink from './ViewDetailsLink';

/** Card for affiliate (agent) hits: avatar + prominent name, then the generic field list. */
const AgentCard: React.FC<{ hit: GlobalSearchHit; onNavigated: () => void }> = ({ hit, onNavigated }) => {
  const nameFragment = hit.highlight?.agent_full_name?.[0];

  return (
    <div className="rounded-lg border border-border bg-card p-4 shadow-sm" data-testid={`global-search-card-${hit.id}`}>
      <div className="flex items-center gap-3">
        <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-muted">
          <User2 className="h-5 w-5 text-muted-foreground" />
        </div>
        <div className="min-w-0 flex-1 truncate text-base font-semibold text-foreground">
          {nameFragment ? <HighlightedText text={nameFragment} /> : hit.agent_full_name || '-'}
        </div>
        <ViewDetailsLink hit={hit} onNavigated={onNavigated} />
      </div>
      <Separator className="my-3" />
      <FieldList hit={hit} />
    </div>
  );
};

export default AgentCard;
